// Focus not obscured (WCAG 2.4.11): the quick-links bar slides in whenever the
// page scrolls, so it can cover the element keyboard focus has just moved to,
// even when it was hidden at that moment.
//   - Mobile: the bar is fixed to the bottom of the screen; keep the focused
//     element above its strip.
//   - Desktop: the bar is a vertical strip on the right edge (it covered the
//     ticker's "Close ticker" button); move the focused element above or below
//     the strip, whichever needs the shorter scroll.
// Mouse and touch focus are left alone.
const BAR = ".quick__links__inner";
const HEADER = ".header--container";
const SCROLL_BUTTON = ".scroll-widget";
const GAP = 8;
const mobile = window.matchMedia("(max-width: 767.98px)");
let keyboard = false;

document.addEventListener("keydown", (event) => {
    keyboard = event.key === "Tab";
}, true);
document.addEventListener("pointerdown", () => {
    keyboard = false;
}, true);

// Where the desktop bar sits once it has slid in. Its transform changes while
// it slides in and out, so the box is worked out from its fixed position
// (top is its centre: it is moved up by half its height when shown).
function shownBarRect(bar) {
    const style = window.getComputedStyle(bar);
    const right = window.innerWidth - (parseFloat(style.right) || 0);
    const top = (parseFloat(style.top) || 0) - bar.offsetHeight / 2;
    return { left: right - bar.offsetWidth, right, top, bottom: top + bar.offsetHeight };
}

// The scroll-to-top button sits under the desktop bar and appears once the
// page scrolls, so the space below the bar ends at its top (when the focused
// element is in its column). Its size is assumed while it is still hidden.
function scrollButtonTop(rect) {
    const button = document.querySelector(SCROLL_BUTTON);
    if (!button) {
        return window.innerHeight;
    }
    const style = window.getComputedStyle(button);
    const right = window.innerWidth - (parseFloat(style.right) || 0);
    const size = button.offsetHeight || 56;
    const left = right - (button.offsetWidth || size);
    if (rect.right < left - GAP || rect.left > right + GAP) {
        return window.innerHeight;
    }
    return window.innerHeight - (parseFloat(style.bottom) || 0) - size;
}

function adjustMobile(bar, rect) {
    const limit = window.innerHeight - bar.offsetHeight - GAP;
    if (rect.bottom > limit && rect.top < window.innerHeight) {
        window.scrollBy({ top: rect.bottom - limit, behavior: "instant" });
    }
}

function adjustDesktop(bar, rect) {
    const box = shownBarRect(bar);
    const covered = rect.right > box.left - GAP && rect.left < box.right + GAP &&
        rect.bottom > box.top - GAP && rect.top < box.bottom + GAP;
    if (!covered) {
        return;
    }
    const header = document.querySelector(HEADER);
    const minTop = (header ? header.getBoundingClientRect().bottom : 0) + GAP;
    const maxBottom = scrollButtonTop(rect) - GAP;
    // Scroll down so the element sits above the bar, or up so it sits below it
    // (only when the page can scroll that far: not up at the very top, not
    // down at the very bottom).
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    const options = [rect.bottom - (box.top - GAP), rect.top - (box.bottom + GAP)]
        .filter((delta) => rect.top - delta >= minTop && rect.bottom - delta <= maxBottom &&
            window.scrollY + delta >= 0 && window.scrollY + delta <= maxScroll);
    if (options.length) {
        const delta = options.reduce((a, b) => (Math.abs(a) <= Math.abs(b) ? a : b));
        window.scrollBy({ top: delta, behavior: "instant" });
    }
}

document.addEventListener("focusin", (event) => {
    const bar = document.querySelector(BAR);
    if (!keyboard || !bar || bar.contains(event.target) || !bar.offsetHeight ||
        bar.classList.contains("d-none")) {
        return;
    }
    const target = event.target;
    const adjust = () => {
        const rect = target.getBoundingClientRect();
        if (document.activeElement !== target || !rect.height) {
            return;
        }
        if (mobile.matches) {
            adjustMobile(bar, rect);
        } else {
            adjustDesktop(bar, rect);
        }
    };
    // The site scrolls smoothly: check once the browser has finished bringing
    // the focused element into view. A scroll that was already running can
    // end first, so check after every scroll that ends in the next second
    // (our own scroll is instant and leaves the element clear, so it does not
    // repeat), plus a short fallback when no scroll was needed or scrollend is
    // not supported.
    window.addEventListener("scrollend", adjust);
    window.setTimeout(adjust, 450);
    window.setTimeout(() => window.removeEventListener("scrollend", adjust), 1000);
});
